// src/config/index.js
export default {
  // 公共域名
  baseUrl: 'https://www.sxzycy.cn'
}